
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M.928.008a.933.916 0 00-.933.917v16.174a.933.916 0 00.933.916h16.167a.933.916 0 00.932-.916v-5.787a.933.916 0 00-.932-.917.933.916 0 00-.933.917v4.87H1.86V1.842h4.842a.933.916 0 00.932-.917.933.916 0 00-.932-.917z","overflow":"visible"}}),_c('path',{attrs:{"d":"M11.818.008a.933.916 0 00-.933.917.933.916 0 00.933.916h3.026L7.642 8.918a.933.916 0 000 1.295.933.916 0 001.318 0l7.202-7.075v2.973a.933.916 0 00.933.916.933.916 0 00.932-.916V.925a.933.916 0 00-.932-.917z","overflow":"visible"}})])])
          )
        }
      }
    